import { AIVoiceInputState } from './AIVoiceInput.constants'

export function isAIVoiceInputStateApplying(state) {
  return state === AIVoiceInputState.Applying
}

export function isAIVoiceInputStateConnecting(state) {
  return state === AIVoiceInputState.Connecting
}

export function isAIVoiceInputStateDefault(state) {
  return state === AIVoiceInputState.Default
}

export function isAIVoiceInputStateReady(state) {
  return state === AIVoiceInputState.Ready
}

export function isAIVoiceInputStateRecording(state) {
  return state === AIVoiceInputState.Recording
}

export function isAIVoiceStopActive(voice) {
  return (
    isAIVoiceInputStateReady(voice.state) ||
    isAIVoiceInputStateRecording(voice.state)
  )
}
